export default {
    url: `https://acloud.anteeo.com.pl/api`,
    mqtt: {
        url: `wss://acloud.anteeo.com.pl/mqtt/`,
        protocol: 'wss'
    }
}
